import { useState, useEffect } from 'react';

// Hook personalizado para verificar se a aba está ativa
export const useTabVisibility = (): boolean => {
  // Estado inicial mais preciso
  const [isTabActive, setIsTabActive] = useState<boolean>(() => {
    // Verifica se o documento está visível E se a janela tem foco
    return !document.hidden && document.hasFocus();
  });

  useEffect(() => {
    const updateTabVisibility = (): void => {
      // Combina ambas as condições para máxima precisão
      const isActive = !document.hidden && document.hasFocus();
      setIsTabActive(isActive);
    };

    const handleFocus = (): void => {
      updateTabVisibility();
    };

    const handleBlur = (): void => {
      updateTabVisibility();
    };

    // Eventos de foco da janela (backup e complemento)
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    return (): void => {
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  return isTabActive;
};
